export default {
  init() {

  },
  finalize() {
    // Trigger a map lightbox
    if ($('a[href="#map-lightbox"]').length > 0) {
      $('a[href="#map-lightbox"]').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const $iframe = $('<iframe class="global-lightbox-iframe"></iframe>');
        $('.global-lightbox-wrap #global-lightbox-type-iframe-wrap').append($iframe);

        $iframe.prop('src', 'https://maps.snowdonia.gov.wales/mapSNPA/Aurora.svc/run?script=%5CAurora%5CLIVE%5Ccarneddau_map.AuroraScript%24&nocache=ad4703f1-20ac-3f5b-72d0-b8b2a137a3ba&resize=always&margin_bottom=10');

        $('.global-lightbox-wrap #global-lightbox-type-iframe-wrap').addClass('show');
        $('.global-lightbox-wrap').addClass('show');
        $('body').addClass('overflow-hidden');
      });
    }

    // Close lightbox
    $(document).on('click', function(e) {
      if ($('.global-lightbox-wrap').hasClass('show')) {
        console.log($(e.target));
        if (!$(e.target).hasClass('global-lightbox') && $(e.target).parents('.global-lightbox').length == 0) {
          $('.global-lightbox-wrap').removeClass('show');
          $('body').removeClass('overflow-hidden');
          $('.global-lightbox-wrap .global-lightbox-iframe').remove();
        }
      }
    });

    $('.global-lightbox-wrap .global-lightbox-close').on('click', function() {
      $('.global-lightbox-wrap').removeClass('show');
      $('body').removeClass('overflow-hidden');
      $('.global-lightbox-wrap .global-lightbox-iframe').remove();
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/lightbox.js